import { Button } from "react-bootstrap";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import T from "../../../common/traducao";

const ModalComposicaoProdutoControl = ({children, ...props}) => {

  const constantes = T()

  const { closeModal, titleModal, apenasVisualizar, className, maxWidthModal} = props;

  return (
    <Dialog
      maxWidth={maxWidthModal ?? "lg"}
      fullWidth
      open={!!props.modal}
      onClose={closeModal}
      className={className}
    >
      <DialogTitle>
        <Box display={"flex"} alignItems={"center"} gap={1}>
          <DisplaySettingsIcon sx={{ display: "flex" }} />{" "}
          <Typography
            sx={{ color: "#404044", fontSize: "18px", fontWeight: "bold" }}
          >
            {titleModal}{" "}
          </Typography>
        </Box>
      </DialogTitle>
      <Divider sx={{background:"#000"}}/>
      <DialogContent>
         {children}
      </DialogContent>
      <Divider sx={{background:"#000"}}/>
      <DialogActions sx={{ gap: 1 }}>
        <Button
          onClick={closeModal}
          style={{ background: "crimson", width: "95px", border: "none" }}
        >
          {constantes.Sair}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalComposicaoProdutoControl;
